var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"section-header"},[(_vm.title)?_c('h2',{staticClass:"section-header__title",attrs:{"itemprop":"headline"}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.subtitle)?_c('h3',{staticClass:"section-header__subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }